/**
 * blockRegistry - minimal type -> Component registry for board-report print blocks.
 *
 * Deliberately smaller than src/components/widgets/WidgetRegistry.js: block
 * components carry no layout/metadata concerns, so register/get is all that's
 * needed (YAGNI — no priorities, categories, or unregister).
 */
class BlockRegistry {
  constructor() {
    this.blocks = new Map();
  }

  /**
   * Register a block type.
   * @param {string} type - Block type identifier (e.g. 'spend-summary')
   * @param {React.Component} component - Block component
   */
  register(type, component) {
    this.blocks.set(type, component);
  }

  /**
   * Get a registered block component by type.
   * @param {string} type - Block type identifier
   * @returns {React.Component|null}
   */
  get(type) {
    return this.blocks.get(type) || null;
  }
}

// Singleton instance, mirroring widgetRegistry
const blockRegistry = new BlockRegistry();

export { BlockRegistry };
export default blockRegistry;
